import React from 'react'
import ViewToggleTab from './ViewToggleTab'
class ViewToggleTabs extends React.Component {
  constructor(props) {
    super(props)
    if (this.props.theme_tab) {
      this.state = {
        theme_status: 'active',
        list_status: 'inactive'
      }
    } else {
      this.state = {
        theme_status: 'inactive',
        list_status: 'active'
      };
    }
  }
  changeTab(tab) {
    if (tab === 'list') {
      this.setState({theme_status: 'inactive', list_status: 'active'});
    } else if (tab === 'theme') {
      this.setState({theme_status: 'active', list_status: 'inactive'});
    }
    return this.props.handleTabChange(tab);
  }
  render() {
    return( 
        <table className='view-toggle-tabs'>
          <thead></thead>
          <tbody>
            <tr>
              <ViewToggleTab
                classname={`${this.state.theme_status} leftmost-cell`}
                tab='theme'
                icon='fa fa-th-large'
                text='Themes'
                handleTabChange={this.changeTab.bind(this)}
              />
              <ViewToggleTab
                classname={`${this.state.list_status} rightmost-cell`}
                tab='list'
                icon='fa fa-th-list'
                text='List'
                handleTabChange={this.changeTab.bind(this)}
              />
            </tr>
          </tbody>
        </table>  )
  }
}

export default ViewToggleTabs